import { Component } from '@angular/core';

@Component({
  selector: 'broker-selina-logo-svg',
  templateUrl: './selina-logo-svg.component.svg'
})
export class SelinaLogoSvgComponent {}
